import apiClient from "../../helpers/apiClient"
import { createLoadingSelector } from "./Loading"
import { FETCH_CARDS } from "./Card"
import { paymentService } from "../../service/payment"

const GET_PAYMENT_URL = "GET_PAYMENT_URL"
const GET_PAYMENT_URL_REQUEST = "GET_PAYMENT_URL_REQUEST"
const GET_PAYMENT_URL_SUCCESS = "GET_PAYMENT_URL_SUCCESS"
const GET_PAYMENT_URL_FAILURE = "GET_PAYMENT_URL_FAILURE"

// const initialState = {
// 	errorMessage: "",
// 	successMessage: "",
// 	paymentRequestUrl: {},
// 	orderInfo: "GetPaymentUrlForEgift",
// 	to: "roy@ascentis.com.sg",
// 	toMsg: "test",
// 	fromName: "roy",
// 	fromEmail: "roy@ascentis.com.sg",
// 	fromEmail2: "roy@ascentis.com.sg",
// 	toName: "roy",
// 	toEmail: "roy@ascentis.com.sg",
// 	toEmail2: "roy@ascentis.com.sg",
// 	amt: 100000,
// 	card: null,
// 	transactType: "EGIFT",
// }

const initialState = {
	errorMessage: "",
	successMessage: "",
	paymentRequestUrl: {},
	orderInfo: "GetPaymentUrlForEgift",
	to: "",
	toMsg: "",
	fromName: "",
	fromEmail: "",
	fromEmail2: "",
	toName: "",
	toEmail: "",
	toEmail2: "",
	amt: 0,
	card: null,
	transactType: "EGIFT",
}

const SAVE_FORM_TO_SHOPPING_CART = "SAVE_FORM_TO_SHOPPING_CART"
export const saveFormToShoppingCart = (v) => (dispatch, state) => {
	return dispatch({
		type: SAVE_FORM_TO_SHOPPING_CART,
		payload: v,
	})
}

export const getPaymentUrlLoadingSelector = createLoadingSelector([GET_PAYMENT_URL])
export const getPaymentUrl = (d) => (dispatch, getState) => {
	return dispatch({
		types: [
			GET_PAYMENT_URL_REQUEST,
			GET_PAYMENT_URL_SUCCESS,
			GET_PAYMENT_URL_FAILURE,
		],
		callAPI: (config) => paymentService.getEgiftPaymentUrl(d, config),
		payload: d,
	})
}

export default function reducer(state = initialState, action) {
	const { payload, errorMessage, successMessage } = action
	switch (action.type) {
		case GET_PAYMENT_URL_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case GET_PAYMENT_URL_SUCCESS:
			return { ...state, paymentRequestUrl: payload, successMessage }
		case GET_PAYMENT_URL_FAILURE:
			return { ...state, errorMessage }
		case SAVE_FORM_TO_SHOPPING_CART:
			return { ...state, ...payload }
		default:
			return state
	}
}
